<div class="popup-container">
  <h1 class="dialog-title">{{'QUERY_EXECUTOR.DATALINE'|translateTA}}</h1>
  <nz-divider class="hdivider"></nz-divider>
  <div class="popup-container-detail form-field-density-4 full">
    <div *ngFor="let item of data| keyvalue">

      <div class="tem-field example-full-width" *ngIf="checkSize(item.value)">
        <label class="tem-field-label">{{item.key}}</label>
        <input nz-input type="text" [ngModel]="item.value" readonly>
      </div>
      <div class="tem-field example-full-width" *ngIf="!checkSize(item.value)">
        <label class="tem-field-label">{{item.key}}</label>
        <textarea nz-input [ngModel]="item.value" readonly class="textarea-min-height" [nzAutosize]="{ minRows: 3, maxRows: 8 }"></textarea>
      </div>
    </div>
  </div>
  <nz-divider class="hdivider"></nz-divider>
  <div class="dialog-actions">
    <button nz-button (click)="onNoClick()">{{'close'|translateTA}}</button>
  </div>
</div>
